import type { FC } from 'react';
import { logoIcon } from './assets';
import type { LogoProps } from './types';

export * from './types';

export const Logo: FC<LogoProps> = (props) => {
  const { color, type, children, ...rest } = props;

  return <img src={logoIcon[color][type]} alt="" {...rest} />;
};
